import { z } from 'zod';
import { CalendarDay } from '../../../utils';
import { withPaginationParams } from '../../helpers';

export const List = withPaginationParams(
  z.object({
    search: z.string().optional().nullable(),
    startDate: z.instanceof(CalendarDay).optional(),
    endDate: z.instanceof(CalendarDay).optional(),
  }),
  ['reportDate'],
);
